var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLinkedinLogo = function SvgLinkedinLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#linkedin-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.633 15V4.88H.203V15h3.43ZM1.918 3.497c1.196 0 1.94-.777 1.94-1.748C3.837.756 3.115 0 1.942 0 .767 0 0 .756 0 1.749c0 .97.744 1.748 1.896 1.748h.022ZM5.531 15h3.43V9.348c0-.302.023-.604.114-.82.248-.605.812-1.23 1.76-1.23 1.24 0 1.737.927 1.737 2.288V15h3.43V9.197c0-3.109-1.692-4.555-3.949-4.555-1.85 0-2.663 1.014-3.114 1.705h.023V4.88h-3.43c.044.95 0 10.12 0 10.12V15Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "linkedin-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v15H0z"
  })))));
};
export default SvgLinkedinLogo;